function $39b7d60101e9df4f$export$13357ea9219894be() {
    const scrollContainer = document.querySelector(".scroll-container");
    const scrollItems = document.querySelector(".scroll-items");
    if (!scrollContainer || !scrollItems) return;
    const cloneItems = scrollItems.cloneNode(true);
    scrollContainer.appendChild(cloneItems);
    let scrollSpeed = parseFloat(scrollContainer.getAttribute("data-speed")) || 0.2;
    let hoverPause = scrollContainer.getAttribute("data-hover-pause") === "true";
    let scrollPosition = 0;
    let isHovering = false;
    function moveScroll() {
        if (!isHovering || !hoverPause) {
            scrollPosition += scrollSpeed;
            if (scrollPosition >= 100) scrollPosition = 0;
            scrollItems.style.transform = `translateX(-${scrollPosition}%)`;
            cloneItems.style.transform = `translateX(-${scrollPosition}%)`;
        }
        requestAnimationFrame(moveScroll);
    }
    requestAnimationFrame(moveScroll);
    const childItems = scrollContainer.querySelectorAll(".scroll-items");
    childItems.forEach((item)=>{
        item.addEventListener("mouseenter", ()=>{
            isHovering = true;
        });
        item.addEventListener("mouseleave", ()=>{
            isHovering = false;
        });
    });
}


function $d1717e9512a1cd40$export$e5fc3007b76fa3cd() {
    const VALID_ID_PATTERN = /^[a-zA-Z0-9_-]+$/;
    document.addEventListener("click", (event)=>{
        const triggerElement = event.target.closest("[data-scroll-target]");
        if (!triggerElement) return;
        event.preventDefault();
        const targetId = triggerElement.getAttribute("data-scroll-target");
        if (!VALID_ID_PATTERN.test(targetId)) {
            console.warn(`Invalid scroll target ID: "${targetId}".`);
            return;
        }
        const targetElement = document.querySelector(`[data-scroll-id="${targetId}"]`);
        if (!targetElement) {
            console.warn(`No element found with data-scroll-id="${targetId}".`);
            return;
        }
        targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    });
}


const $d5cecb7d35eaef51$var$stack = document.querySelector(".stack");
const $d5cecb7d35eaef51$var$cards = Array.from($d5cecb7d35eaef51$var$stack.querySelectorAll(".stack-card"));
function $d5cecb7d35eaef51$var$setupInitialPosition() {
    $d5cecb7d35eaef51$var$cards.forEach((card, index)=>{
        if (index === 0) {
            card.style.transform = "translate(0px, 0px) rotate(0deg)";
            card.style.transformOrigin = "left";
            card.style.zIndex = 30;
        } else if (index === 1) {
            card.style.transform = "translate(-30px, -5px) rotate(-8deg)";
            card.style.transformOrigin = "left";
            card.style.zIndex = 20;
        } else {
            card.style.transform = "translate(-60px, 60px) rotate(-16deg)";
            card.style.transformOrigin = "left";
            card.style.zIndex = 10;
        }
    });
}
function $d5cecb7d35eaef51$var$rotateCards() {
    const currentCard = $d5cecb7d35eaef51$var$cards[0];
    currentCard.style.transition = "transform 0.5s ease";
    currentCard.style.transform = "translate(100px, 0px) rotate(20deg)";
    setTimeout(()=>{
        currentCard.style.transition = "transform 0.5s ease";
        currentCard.style.transform = "translate(-60px, 60px) rotate(-16deg)";
        currentCard.style.zIndex = 10;
        const nextCard = $d5cecb7d35eaef51$var$cards[1];
        nextCard.style.transition = "transform 0.5s ease";
        nextCard.style.transform = "translate(0px, 0px) rotate(0deg)";
        nextCard.style.zIndex = 30;
        const lastCard = $d5cecb7d35eaef51$var$cards[2];
        lastCard.style.transition = "transform 0.5s ease";
        lastCard.style.transform = "translate(-30px, -5px) rotate(-8deg)";
        lastCard.style.zIndex = 20;
        $d5cecb7d35eaef51$var$cards.push($d5cecb7d35eaef51$var$cards.shift());
        $d5cecb7d35eaef51$var$setupInitialPosition();
    }, 500);
}
function $d5cecb7d35eaef51$export$1f5a40910027446e(timeout = 2000) {
    const styles = window.getComputedStyle($d5cecb7d35eaef51$var$stack);
    if (styles.getPropertyValue("display") === "none") return;
    $d5cecb7d35eaef51$var$setupInitialPosition();
    setInterval($d5cecb7d35eaef51$var$rotateCards, timeout);
}


document.addEventListener("DOMContentLoaded", ()=>{
    (0, $d5cecb7d35eaef51$export$1f5a40910027446e)();
    (0, $39b7d60101e9df4f$export$13357ea9219894be)();
    (0, $d1717e9512a1cd40$export$e5fc3007b76fa3cd)();
    $b63be9b0371e788c$var$setupFormSubmission();
});
function $b63be9b0371e788c$var$setupFormSubmission() {
    const submitButton = document.getElementById("form-submit-button");
    const successMessage = document.getElementById("success-message");
    const form = submitButton?.closest("form") || submitButton?.parentElement?.closest('div[class*="flex-col"]'); // Try to find form or parent div
    if (submitButton && successMessage && form) submitButton.addEventListener("click", (event)=>{
        event.preventDefault(); // Prevent default form submission
        // Assuming your form has input fields you might want to clear or process
        const fullNameInput = document.getElementById("fullName");
        const phoneNumberInput = document.getElementById("phoneNumber");
        // Basic validation example (optional)
        fullNameInput.value.trim() === "" || phoneNumberInput.value.trim();
        // Display the success message
        successMessage.classList.remove("hidden");
        // Optional: Clear form fields after submission
        if (fullNameInput) fullNameInput.value = "";
        if (phoneNumberInput) phoneNumberInput.value = "";
        // Optional: Hide the message after a few seconds
        setTimeout(()=>{
            successMessage.classList.add("hidden");
        }, 5000); // Hide after 5 seconds
    });
    else {
        if (!submitButton) console.error("Submit button not found");
        if (!successMessage) console.error("Success message element not found");
        if (!form) console.error("Form or form container not found to attach event listener for submission logic. The button's parent is:", submitButton?.parentElement);
    }
}


//# sourceMappingURL=index.f7e8fe56.js.map
